import { HOW_OFTEN_CAN_I_UPDATE_CONTENT_ID } from "@faire/help-center-utils/articleIds";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalMyShop from "@faire/web-api--source/routes/brand-portal/marketplace";
import brandPortalShopPage from "@faire/web-api--source/routes/brand-portal/my-shop/story";
import supportArticle from "@faire/web-api--source/routes/support/articles/articleId";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";

export const ShopImageryIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="Your shop imagery can help new retailers discover and get to know your brand. Your feature image, cover image, profile image, and logo will appear in various places on Faire. To view or update all of your shop imagery, go to the <ShopPageLinkFormatting>Shop page</ShopPageLinkFormatting> under <MyShopLinkFormatting>My shop</MyShopLinkFormatting>."
          values={{
            ShopPageLinkFormatting,
            MyShopLinkFormatting,
          }}
          description={{
            text: "Introduction to shop imagery",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Here’s what to know about your feature and cover images:"
          description={{
            text: "Header for feature and cover images information",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="<BoldFormatting>Feature image:</BoldFormatting>"
          values={{
            BoldFormatting,
          }}
          description={{
            text: "Header for introduction to feature image",
          }}
        />
      </Typography>
      <Typography>
        <StrictLocalMsg
          defaultMessage="This is your primary image featured across the platform and will be reviewed by our design team. It can be your first introduction to retailers, so using a captivating, high-quality image (500 x 500 pixels) is crucial. The feature image must be a single image, not a collage, and cannot include logos, watermarks, or text."
          description={{
            text: "Introduction to feature image",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="<BoldFormatting>Cover image:</BoldFormatting>"
          values={{
            BoldFormatting,
          }}
          description={{
            text: "Header for introduction to cover image",
          }}
        />
      </Typography>
      <Typography>
        <StrictLocalMsg
          defaultMessage="Your cover image appears at the top of your brand page and sets the tone for your shop. This image must be high resolution (1000 x 1000 pixels) and can’t contain logos, text, photo collages, products with inappropriate language, or nudity. For examples of what makes a great cover image, visit <LinkFormatting>Cover image guidelines</LinkFormatting>."
          values={{
            LinkFormatting: ArticleLinkFormatting,
          }}
          description={{
            text: "Introduction to cover image",
          }}
        />
      </Typography>
    </Column>
  );
};

const ShopPageLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalShopPage()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const MyShopLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalMyShop()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;

const ArticleLinkFormatting = (chunks: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={supportArticle(HOW_OFTEN_CAN_I_UPDATE_CONTENT_ID)}
    target="_blank"
  >
    {chunks}
  </Button>
);
